<template>
  <div>
    <div
      v-for="(message, i) in messages"
      :key="i"
      class="pega-sent-message"
      :class="{'pega-received-message': message.fromOthers}"
      :data-test="`message-${i}`"
    >
      <div class="boss-message-header-layout">
        <span :data-test="`send-date-${i}`">{{ message.sendDate }}</span>
        <div
          class="boss-layout-block boss-message-when pega-break-all"
          :data-test="`sender-${i}`"
        >
          差出人：{{ message.senderInfo.name }} ({{ message.senderInfo.email }})
        </div>
      </div>
      <div class="boss-layout-block">
        <div class="boss-message-mail-subject">
          TO：<span
            v-for="(to, j) in message.toReceivers"
            :key="`to-${i}-${j}`"
            :data-test="`to-${i}-${j}`"
          >{{ to.name }} ({{ to.email }})</span><br>
          CC：<span
            v-for="(cc, j) in message.ccReceivers"
            :key="`cc-${i}-${j}`"
            :data-test="`cc-${i}-${j}`"
          >{{ cc.name }} ({{ cc.email }})</span>
        </div>
        <div
          class="pega-pre-wrap"
          :data-test="`message-body-${i}`"
          v-html="$sanitize(renderBody(message.body))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/lib/util'

export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    renderBody (body) {
      return util.replaceAddressAndUrlLink(body)
    }
  }
}
</script>
